import * as React from 'react';
import SimpleLoader from '../../../core/src/SimpleLoader';
import SeatInfoGroup from '@websky/core/src/SeatMap/components/SeatsInfo/SeatInfoGroup/SeatInfoGroup';
import Order from './Checkout/Order/Order';
import { iraeroEquipmentIcons } from './HeaderEquipmentItem/icons';
import { SportEquipment } from '@websky/core';
import { Form } from '@websky/core/src/Checkout/components/Checkout/Form/Form';
import { renderCheckoutLinksLabel } from './InfoLinksLabel/InfoLinksLabel';
import CheckoutServicesV2 from '@websky/core/src/Checkout/components/Checkout/ServicesV2/ServicesV2';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
export const iraeroRenderers = {
    renderPromoLoaderContent: () => React.createElement(SimpleLoader, null),
    CheckoutForm: props => React.createElement(Form, Object.assign({}, props, { showCheckDataModal: true })),
    SeatInfoGroup: props => React.createElement(SeatInfoGroup, Object.assign({}, props, { fullInfo: false })),
    renderHeaderEquipmentIcon: rfics => { var _a; return (_a = iraeroEquipmentIcons[rfics]) !== null && _a !== void 0 ? _a : SportEquipment; },
    renderOrderRoute: Order,
    renderCheckoutLinksLabel,
    CheckoutServices: CheckoutServicesV2,
    CheckinServices: CheckinServicesV2
};
